export const getCols = (cols: number, sizes?: Array<[string, number | undefined]>): string => `grid-cols-${cols} ${(sizes != null) ? sizes.map(s => s[1] !== undefined ? `${s[0]}:grid-cols-${s[1]}` : '').join(' ') : ''}`
